import React, { useContext } from 'react';

import { CardListSkeleton } from '@eika-kortbetjening/card-list-panel';
import { ErrorCard } from '@eika/card';

import CardControlContext from '@/context/card-control/CardControlContext';
import useCardRules from '@/react-query/hooks/query/use-card-rules';

import useText from '@hooks/use-text';

import Ecommerce from './Ecommerce';
import { Setting } from './Setting';
import { SettingInfo } from './modals/InfoModal';

export const EcommerceSetting = () => {
    const { data: cardRules, isLoading: isLoadingCardRules, isError } = useCardRules();
    const text = useText();
    const { selectInfoModal } = useContext(CardControlContext);

    if (isError) {
        return <ErrorCard title={text.regionBlockFetchError} />;
    }

    if (isLoadingCardRules || typeof cardRules === 'undefined') {
        return <CardListSkeleton panelCount={1} />;
    }

    return (
        <Setting title={text.regionEcommerce} onInfoClick={() => selectInfoModal(SettingInfo.Ecommerce)}>
            <Ecommerce />
        </Setting>
    );
};
